import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppIcon } from './app-icon-list.model';
@Component({
  selector: 'app-icon-list',
  templateUrl: './app-icon-list.component.html',
  styleUrls: ['./app-icon-list.component.scss'],
})
export class AppIconListComponent  {
  @Input() icons: AppIcon[] = [];
  @Output() iconClick = new EventEmitter<AppIcon>();

  handleImageError(event: ErrorEvent, index: number): void {
    if (!event.target) {
      return;
    }

    event.target.removeEventListener('error', null);
    this.icons[index].forceDefaultLogo = true;
  }

  handleIconSelected(icon: AppIcon): void {
    this.iconClick.emit(icon);
  }
}
